<template>
  <div class="bread-crumb pd-medium-horizontal">
    <a href="javascript:;">社商经营</a>
    <a href="javascript:;">丁老板</a>
    <a
      href="javascript:;"
      v-if="item.link"
      v-for="(item,index) in crumbList"
      :key="index"
      @click="clickEvent"
    >{{item.name}}</a>
    <a
      href="javascript:;"
      v-if="!item.link"
      v-for="(item,index) in crumbList"
      :key="index"
    >{{item.name}}</a>
  </div>
</template>
<script>
export default {
  props: {
    crumbList: Array
  },
  methods: {
    clickEvent() {
      this.$emit("crumbClick", true);
    }
  }
};
</script>
<style lang="less" module>
.bread-crumb {
  padding: 0 20px;
  display: flex;
  align-items: center;
  height: 40px;
  border-bottom: #ebf1f5 1px solid;
  a {
    font-size: 14px;
    color: #a0abbf;
    position: relative;
    padding-right: 20px;
    padding-left: 5px;
    &:hover {
      color: #4f9efa;
    }
    &:before,
    &:after {
      display: block;
      content: "";
      width: 0;
      border-width: 5px;
      border-style: solid;
      position: absolute;
      top: 50%;
      margin-top: -5px;
    }
    &:before {
      border-color: transparent transparent transparent #a0abbf;
      right: -1px;
    }
    &:after {
      border-color: transparent transparent transparent #fff;
      right: 1px;
    }
    &:first-child {
      padding-left: 0;
    }
    &:last-child {
      &:before,
      &:after {
        display: none;
      }
    }
  }
}
</style>


